module.exports = __webpack_public_path__ + "img/pestanas-5.03c79514.svg";